import 'reset-css/reset.css';
import '../scss/site.scss';

import {App} from './Lib';

const app = new App();

app.init();
